import { render } from "./MenuBar.vue?vue&type=template&id=492af60e"
import script from "./MenuBar.vue?vue&type=script&lang=js"
export * from "./MenuBar.vue?vue&type=script&lang=js"
script.render = render

export default script